<template>
    <div class="booking general clearfix">
        <div class="data">
            <table>
                <tbody>
                    <tr>
                        <th colspan="2">
                            {{ 'shopcart.article' | trans}}
                        </th>
                        <th>
                            {{ 'shopcart.quantity' | trans }}
                        </th>
                        <th>
                            {{ 'shopcart.price' | trans }}
                        </th>
                    </tr>
                    <shop-article
                        v-for="({id, image, icon, title,
                            quantity, price, attributes}, index) in articles"
                        :editable="editable"
                        :key="index"
                        :id="id"
                        :image="image"
                        :icon="icon"
                        :title="title"
                        :quantity="quantity"
                        :price="price"
                        :attributes="attributes"
                        @update='updateArticle($event, index)'
                        @delete='deleteArticle'
                    />
                </tbody>
            </table>
        </div>
        <div class="price">
            <articles-price
                :total="total"
            />
        </div>
    </div>
</template>

<script>
    import { sum } from 'ramda';
    import ShopArticle from './ShopArticle';
    import ArticlesPrice from './ArticlesPrice';

    export default {
        name: 'articles',
        props: {
            articles: {
                type: Array,
                required: true
            },
            editable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                total: 0
            };
        },
        methods: {
            deleteArticle(id) {
                const data = {
                    type: 'delete',
                    data: id
                };
                this.$emit('update', data);
            },
            updateArticle(article, index) {
                this.articles[index] = article;
                this.updateTotal();

                const data = {
                    type: 'update',
                    data: this.articles[index]
                };
                this.$emit('update', data);
            },
            updateTotal() {
                const total = this.articles.map(({ quantity, price }) => price * quantity);
                this.total = sum(total);
            }
        },
        beforeUpdate() {
            this.updateTotal();
        },
        components: {
            ShopArticle,
            ArticlesPrice
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Articles.vue